module.exports = __webpack_public_path__ + "img/wx-scan-guide.fe23fcb3.jpg";